import { BrowserStorage } from '@estee/elc-universal-utils';

export const setLocalStorageItem = (key: string, value: string) => {
    return BrowserStorage.setItem(key, value, 'localStorage');
};

export const removeLocalStorageItems = (keys: string[]) => {
    return keys.forEach((key) => BrowserStorage.removeItem(key, 'localStorage'));
};

export const getLocalStorageItem = (key: string) => {
    return BrowserStorage.getItem(key, 'localStorage');
};
